<template>
  <section class="buttons">
    <p>
      <app-content-nav-link class="btn btn_back btn_seznam" v-if="navLinkTo" :link="navLinkTo" :text="navLinkTitle" />
      <slot />
    </p>
  </section>
</template>

<script>
export default {
  name: 'app-settings-buttons',
  props: {
    navLinkTitle: String,
    navLinkTo: [Object, String]
  }
}
</script>
